import { useScrollBlock } from '@repo-level/core-front';
import { ErrorBlock } from './ErrorBlock';

export const InternalError = () => {
  useScrollBlock();

  return (
    <ErrorBlock
      withBg
      text={'Elf technicians at work'}
      subText={`A mischievous someone is playing tricks on the website. We're working to fix it!`}
      buttonText={'Elf central'}
    />
  );
};
